type UsernameHintProps = {
  show: boolean;
  status?: boolean | string;
};

const UsernameHint = ({ show, status }: UsernameHintProps) => {
  return (
    <>
      {show && (
        <div className="w-72 absolute border-solid border-grey-10 right-72 -top-12 p-4 border z-10 bg-white rounded-xl shadow-md">
          <h5 className="text-sm font-semibold">CREATE USERNAME</h5>
          <p className="text-grey-50 text-sm mt-2">
            Please create an unique username using the following characters
            only:
          </p>
          <div className="mt-5">
            <div className="flex items-center">
              <span
                className={`material-icons text-base ${
                  status ? 'text-grey-30' : 'text-primary'
                }`}
              >
                check_circle
              </span>
              <span className="text-sm ml-2">
                Letters (A-Z), numbers (0-9) and dashes (-_)
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default UsernameHint;
